import React, {useState, useRef} from "react";

import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";

import {BULK_CREATE_ASSET_IMAGES_MUTATION} from "../../../../constants/graphql";
import useMutation from "../../../../hooks/useMutation";
import useNotification from "../../../../hooks/notification";
import {useOnEnterEffect} from "../../../../utils/keyEffects";

export default function FileField({ id, innerRef, onChange, selected, entity }) {
  const [loading, setLoading] = useState(false);
  const [addImageMutation] = useMutation(BULK_CREATE_ASSET_IMAGES_MUTATION);
  const { notifySuccess, notifyError } = useNotification();
  const inputRef = useRef(null);

  const onUpload = event => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    setLoading(true);
    addImageMutation({
      variables: { assetId: entity.id, images: Array.from(files) },
      onSuccess: ({ asset }) => {
        setLoading(false);
        notifySuccess("Images successfully uploaded!");
        onChange(entity.id, { photo: asset.photo, images: asset.images }, { skipMutation: true });
        if (inputRef.current) inputRef.current.value = "";
      },
      onFailure: errors => {
        notifyError(errors.submit);
        setLoading(false);
      },
    });
  };

  const handleAction = (e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    inputRef.current?.click();
  };

  useOnEnterEffect(innerRef, selected ? handleAction : null);

  const inputId = `contained-button-file-${id}-${entity.id}`;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
    >
      <input
        ref={inputRef}
        id={inputId}
        disabled={loading}
        style={{ display: "none" }}
        type="file"
        multiple={true}
        accept="image/*"
        onChange={onUpload}
      />
      {loading ? (
        <CircularProgress size={26} />
      ) : (
        <label
          htmlFor={inputId}
          style={{ cursor: "pointer", display: "block" }}
          onClick={e => e.stopPropagation()}
          onMouseDown={e => e.stopPropagation()}
        >
          <IconButton
            ref={innerRef}
            component="span"
            disabled={loading}
            size="small"
          >
            <CloudUploadOutlinedIcon color="action" />
          </IconButton>
        </label>
      )}
    </Box>
  );
}
